<script>
import Timestamp from '@components/timestamp/timestamp'

export default {
  components: { Timestamp },
  props: {
    itemVideo: {
      type: Object,
      default: () => {},
    },
    zoom: {
      type: Boolean,
      default: false,
    },
    action: {
      type: Function,
      default: () => {},
    },
    removeManually: {
      type: Boolean,
      default: false,
    },
    uploadVideos: {
      type: Boolean,
      default: false,
    },
    selectManually: {
      type: Boolean,
      default: false,
    },
    idSelected: {
      type: String,
      default: '',
    },
    campaignSelection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      elementSelect: '',
    }
  },
  computed: {
    itemThumbnail() {
      if (
        this.itemVideo &&
        this.itemVideo.thumbnail &&
        this.itemVideo.thumbnail.medium
      ) {
        return this.itemVideo.thumbnail.medium
      }
      return 'https://www.alphavoice.io/static/images/placeholder-video-img.png'
    },
  },
  mounted() {
    if (this.idSelected) {
      this.elementSelect = this.idSelected.toString()
    }
  },
  methods: {
    truncate: (what, length = 25) => {
      if (what.length > length) {
        what = what.substr(0, length)
        what += '...'
        return what
      }
      return what
    },
    selectvideo(e) {
      const element = e.target
      element.classList.toggle('active')
      let result = e.target.id
      if (result === this.elementSelect) {
        this.elementSelect = ''
        this.$emit('action', null)
      } else {
        this.elementSelect = result
        this.$emit('action', result)
      }
    },
  },
}
</script>
<template>
  <div
    class="video-list-item"
    @click="campaignSelection && action(itemVideo.id)"
  >
    <div
      v-if="idSelected && idSelected.toString() !== itemVideo.id.toString()"
      class="video-list-item-disabled"
    />
    <button
      v-if="removeManually"
      class="video-list-item-remove position-absolute p-0 text-white bg-transparent border-0"
      @click="action(itemVideo.id)"
    >
      <BaseIcon name="times" />
    </button>
    <button
      v-if="selectManually"
      class="video-list-item-remove position-absolute p-0 text-white bg-transparent border-0 pt-2"
    >
      <div
        :id="itemVideo.id"
        class="check-btn"
        :class="{
          active:
            idSelected && idSelected.toString() === itemVideo.id.toString(),
        }"
        @click="selectvideo"
      >
        <span class="check-filled"></span>
      </div>
    </button>
    <div class="video-list-item-body">
      <img :src="itemThumbnail" alt="" />
      <div class="video-list-item-info">
        <!-- <span class="video-views t-xs text-info">
          <span class="mr-1">
            <BaseIcon name="eye" />
          </span>
        </span> -->
        <Timestamp
          :video-duration="
            !uploadVideos
              ? itemVideo.duration && itemVideo.duration
              : itemVideo.content_audio &&
                Number(itemVideo.content_audio.audio_length)
          "
        />
      </div>

      <div class="video-list-item-title">
        <!-- <span class="t-md"><BaseIcon name="play-circle" /></span> -->
        <div v-if="zoom" class="title">{{
          itemVideo.title !== '' && itemVideo.title
        }}</div>
      </div>
    </div>

    <div class="video-list-item-caption text-dark p-1">
      <div
        v-if="idSelected && idSelected.toString() !== itemVideo.id.toString()"
        class="video-list-item-disabled"
      />
      <small class="h6">
        {{ itemVideo.title !== '' && truncate(itemVideo.title, 50) }}
      </small>
    </div>
  </div>
</template>
